import useTrailers from '@/hooks/useTrailers';

interface Props {
	gameId: string;
}

const GameTrailer = ({ gameId }: Props) => {
	const { data: movies, error, isLoading } = useTrailers(gameId);

	if (isLoading) return null;

	if (error) throw error;

	const video = movies?.[0];

	return video ? (
		<video src={video?.data[480]} poster={video?.preview} controls />
	) : null;
};

export default GameTrailer;
